"use strict";

import jQuery from 'jquery';

/**
 * Control zum leeren der Trackinglayer.
 *
 * @class
 * @extends gc.gis.control.GCAbstractMapControl
 * @memberof gc.gis.control
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen (siehe {@link gc.gis.control.GCAbstractMapControl})
 */
gc.gis.control.GCDrawingAreaClear = function(options)
{
	gc.gis.control.GCAbstractMapControl.call(this, options);

	/**
	 * Liste der überwachten TrackingLayer.
	 *
	 * @type {gc.gis.layer.GCTrackingLayer[]}
	 * @private
	 */
	this._trackingLayers = [];

	/**
	 *
	 * @type {undefined|number}
	 * @private
	 */
	this._update_timer = undefined;
};
gc.gis.control.GCDrawingAreaClear.prototype = Object.create(gc.gis.control.GCAbstractMapControl.prototype);

/**
 * @inheritdoc
 */
gc.gis.control.GCDrawingAreaClear.prototype.init = function()
{
	this._render();

	// Sonderbehandlung, wegen race condition: Map-Objekt mit HighlightLayer existiert, bevor Mapcontrols erzeugt werden)
	this._addObserveLayer(this._map.getMap().getHighlightLayer());

	// Events initialisieren
	this._map.getMap().on(gc.gis.map.GCMapEvent.TRACKINGLAYER_ADDED, this, function (evt) {
		this._addObserveLayer(evt.layer);
	});

	this._map.getMap().on(gc.gis.map.GCMapEvent.TRACKINGLAYER_REMOVED, this, function (evt) {
		this._removeObserveLayer(evt.layer);
	});

	this._map.getMap().on(gc.gis.map.GCMapEvent.TRACKINGLAYER_REMOVED_ALL, this, function (evt) {
		this._resetObserveLayer();
	});
};

/**
 * Rendert das Control.
 *
 * @protected
 * @return {jQuery} Container-Element
 */
gc.gis.control.GCDrawingAreaClear.prototype._render = function()
{
	var self = this;

	if(!this._element)
	{
		this._element = jQuery('<div>', {
			'class': 'gc-map-control gc-map-control-drawingarea-clear'
		});
		this._element.hide();

		this.__element_clear = jQuery('<button>', {
			'class': 'gc-map-control-button gc-map-control-button-drawingarea-clear',
			title: 'Zeichenfläche leeren',
			html: '<span>Zeichenfläche leeren</span>',
			click: function(evt)
			{
				evt.preventDefault();
				try
				{
					self._doClear();
				}
				catch( err )
				{
					gc.gis.iface.log.error(self, err);
				}
				jQuery(this).blur();
			}
		});
		this.__element_clear.prepend(jQuery('<span>', {
			'class': 'gc-icon glyphicon glyphicon-erase'
		}));

		this._element.append(this.__element_clear);
		gc.gis.iface.ui.tooltip(this.__element_clear, {
			placement: 'auto left'
		});
	}
	return this._element;
};

/**
 * Fügt einen Tracking-Layer, sofern dieser relevant für die Verarbeitung ist, der internen Referenzliste hinzu.
 *
 * @private
 * @param {gc.gis.layer.GCTrackingLayer} layer
 */
gc.gis.control.GCDrawingAreaClear.prototype._addObserveLayer = function(layer)
{

	if (layer.allowClearDrawingArea())
	{
		this._trackingLayers.push(layer);
		this._initLayerEvents(layer);
		this._doUpdateGUI();
	}
};

/**
 * Entfernt einen Tracking-Layer, sofern dieser in der internen Referenzliste vorhanden ist.
 *
 * @private
 * @param {gc.gis.layer.GCTrackingLayer} layer
 */
gc.gis.control.GCDrawingAreaClear.prototype._removeObserveLayer = function(layer)
{
	for(var i=0; i<this._trackingLayers.length; i++)
	{
		if(this._trackingLayers[i] === layer)
		{
			delete this._trackingLayers[i];
			this._trackingLayers[i].splice(i, 1);
			i--;

			this._reinitLayerEvents(layer);
			this._doUpdateGUI();
		}
	}
};

/**
 * Setzt die internen Referenzliste der beobachteten Tracking-Layer zurück.
 *
 * @private
 */
gc.gis.control.GCDrawingAreaClear.prototype._resetObserveLayer = function()
{
	for(var i=0; i<this._trackingLayers.length; i++)
	{
		this._reinitLayerEvents(this._trackingLayers[i]);
	}

	this._trackingLayers = [];
	this._doUpdateGUI();
};

/**
 * Initialisiert die Events zum Überwachen eines Layers.
 *
 * @param {gc.gis.layer.GCTrackingLayer} layer
 * @private
 */
gc.gis.control.GCDrawingAreaClear.prototype._initLayerEvents = function(layer)
{
	layer.on(gc.gis.layer.GCVectorLayerEvent.FEATURE_ADDED, this, function (evt) {
		this._doUpdateGUI();
	});

	layer.on(gc.gis.layer.GCVectorLayerEvent.FEATURE_REMOVED, this, function (evt) {
		this._doUpdateGUI();
	});

	layer.on(gc.gis.layer.GCVectorLayerEvent.LAYER_CLEARED, this, function (evt) {
		this._doUpdateGUI();
	});
};

/**
 * Entfernt die Events zum Überwachen eines Layers.
 *
 * @param {gc.gis.layer.GCTrackingLayer} layer
 * @private
 */
gc.gis.control.GCDrawingAreaClear.prototype._reinitLayerEvents = function(layer)
{
	layer.un(gc.gis.layer.GCVectorLayerEvent.FEATURE_ADDED, this);
	layer.un(gc.gis.layer.GCVectorLayerEvent.FEATURE_REMOVED, this);
	layer.un(gc.gis.layer.GCVectorLayerEvent.LAYER_CLEARED, this);
};

/**
 * Führt die Ereignisbehandlungsroutine zur Aktualisierung der Darstellung des "Zeichenfläche leeren"-Buttons aus.
 *
 * @private
 */
gc.gis.control.GCDrawingAreaClear.prototype._doUpdateGUI = function()
{
	var self = this;

	// "Ruckeln" des Button über Timer unterbinden (z.B. wenn bei "Gehe zu" erst clear- und dann addFeature-Methode aufgerufen wird)
	if(self._update_timer)
	{
		clearTimeout(self._update_timer);
	}

	this._update_timer = setTimeout(function() {
		try
		{
			var cnt = 0;
			for(var i=0; i<self._trackingLayers.length && cnt === 0; i++)
			{
				cnt += self._trackingLayers[i].numFeatures();
			}

			var opts = {
				duration: 250,
				easing: 'linear'
			};
			if (cnt > 0)
			{
				self._element.show(opts);
			}
			else
			{
				self._element.hide(opts);
			}
		}
		catch(err)
		{
			gc.gis.iface.log.error(this, err);
		}
		finally
		{
			self._update_timer = undefined;
		}
	}, 250);
};

/**
 * Führt die Ereignisbehandlungsroutine zum Leeren der relevanten Tracking-Layer aus.
 *
 * @private
 */
gc.gis.control.GCDrawingAreaClear.prototype._doClear = function()
{
	var i, ii, action;
	for(i = 0, ii = this._trackingLayers.length; i < ii; i++)
	{
		action = this._trackingLayers[i].getClearDrawingAreaAction();
		if (action instanceof gc.gis.action.GCAbstractAction)
		{
			action.execute(this._trackingLayers[i]);
		}
		else
		{
			this._trackingLayers[i].clear();
		}
	}
};